<template>

    <form @submit.prevent="save()" class="material-form" @keydown="errors.clear('generic')" ref="materialForm">

        <input type="file" id="file" name="file" ref="fileUpload" v-show="false" @change="onFileChange($event)"/>

        <div class="material-file-input">
            <svg width="63" height="71" class="material-icon"><use :xlink:href="'#' + basicType(material)"></use> </svg>
            <h6>{{ material.file ? material.file.name : material.title }}</h6>
            <button v-if="material.type === 'file'" type="button" class="button hollow secondary small" @click="onFileUpload($event)">Aizstāt</button>
        </div>

        <span class="form-error is-visible" v-if="errors.has('file')">{{ errors.first('file') }}</span>

        <label :class="{ 'is-invalid-label': errors.has('title') }">Nosaukums
            <input type="text" v-model="material.title" v-validate="'required|max:250'" name="title" id="title"/>
            <span class="form-error is-visible" v-if="errors.has('title')">{{ errors.first('title') }}</span>
        </label>

        <label v-if="material.type === MATERIAL_TYPE_LINK" :class="{ 'is-invalid-label': errors.has('uri') }">Interneta resursa saite
            <input type="text" v-model="material.uri" placeholder="https://..." name="uri" id="uri" v-validate="uriValidationRule"/>
            <span class="form-error is-visible" v-if="errors.has('uri')">{{ errors.first('uri') }}</span>
        </label>

        <label :class="{ 'is-invalid-label': errors.has('description') }">Apraksts
            <textarea v-model="material.description" name="description" id="description" :class="{ 'is-invalid-input': errors.has('description') }" v-validate="'max:1000'" rows="4"></textarea>
            <div class="text-right note">Atlikušo simbolu skaits: {{ material.description ? 1000 - material.description.length : 1000}}</div>
            <span class="form-error is-visible" v-if="errors.has('description')">{{ errors.first('description') }}</span>
        </label>

        <div class="row small-up-1 medium-up-2">

            <label class="column" :class="{ 'is-invalid-label': errors.has('classCategory') }">Klase
                <select v-model="classCategory"
                        v-validate="'required'"
                        name="classCategory" id="classCategory"
                        :class="{ 'is-invalid-input': errors.has('classCategory') }">
                    <option :value="null" disabled hidden>Izvēlies klasi...</option>
                    <option :value="c.category" v-for="c in categories" :key="c.id">{{ c.category.title }}</option>
                </select>
                <span class="form-error is-visible" v-if="errors.has('classCategory')">{{ errors.first('classCategory') }}</span>
            </label>


            <label v-if="classCategory" class="column" :class="{ 'is-invalid-label': errors.has('themeCategory') }">Tēma
                <select v-model="themeCategory"
                        v-validate="'required'"
                        name="themeCategory" id="themeCategory"
                        :class="{ 'is-invalid-input': errors.has('themeCategory') }"
                        :disabled="themeCategoryNodes.length === 0">
                    <option :value="null" disabled hidden>Izvēlies tēmu...</option>
                    <option :value="theme.category" v-for="theme in themeCategoryNodes" :key="theme.id">{{ theme.category.title }}</option>
                </select>
                <span class="form-error is-visible" v-if="errors.has('themeCategory')">{{ errors.first('themeCategory') }}</span>
            </label>

            <label v-if="themeCategory" class="column" :class="{ 'is-invalid-label': errors.has('typeCategory') }">Tips
                <select v-model="typeCategory"
                        v-validate="'required'"
                        name="typeCategory" id="typeCategory"
                        :class="{ 'is-invalid-input': errors.has('typeCategory') }"
                        :disabled="typeCategoryNodes.length === 0">
                    <option :value="null" disabled hidden>Izvēlies tipu...</option>
                    <option :value="t.category" v-for="t in typeCategoryNodes" :key="t.id">{{ t.category.title }}</option>
                </select>
                <span class="form-error is-visible" v-if="errors.has('typeCategory')">{{ errors.first('typeCategory') }}</span>
            </label>

        </div>

        <div class="form-element" v-if="user">
            <label class="inline-form-element" :class="{ 'is-invalid-label': errors.has('signature_type') }">Ievietot kā</label>
            <label class="inline-form-element"><input type="radio" v-model="material.signature_type" v-validate="'required|in:name,pseudonym'" name="signature_type" value="name"/> {{ user.name }}</label>
            <label class="inline-form-element" v-if="user.pseudonym"><input type="radio" v-model="material.signature_type" name="signature_type" value="pseudonym"/> {{ user.pseudonym }}</label>
            <span class="form-error is-visible" v-if="errors.has('signature_type')">{{ errors.first('signature_type') }}</span>
        </div>

        <progress v-if="submitting" max="100" :value="progress"></progress>
    </form>

</template>

<script>
    import categories from '../../api/categories'
    import materials from '../../api/materials'
    import { mapGetters } from 'vuex'

    const MATERIAL_TYPE_FILE = 'file';
    const MATERIAL_TYPE_LINK = 'link';

    export default {

        props: ['material'],

        created() {
            if (this.categories.length === 0) {
                this.$store.dispatch('getCategories');
            }

            this.$validator.localize('lv', {
                custom: {
                    signature_type: {
                        required: 'Lūdzu, norādi, kā vārdā ievietot materiālu.'
                    }
                }
            });

            //Object.assign(this.$data.model, this.material);
        },

        data() {
            return {
                MATERIAL_TYPE_FILE,
                MATERIAL_TYPE_LINK,

                // TODO implement object copy?
               // model: {
               //     id: null,
               //     title: null,
               //     uri: null,
               //     type: null,
               //     mime_type: null,
               //     description: null,
               //     signature_type: null,
               //     categories: [],
               //     file: null
               // },

                submitting: false,
                progress: 0,
            }
        },

        methods: {

            /**
             * Get categories or request if not loaded and return promise
             * @returns {Promise<any>}
             */
            async getCategories() {
                return this.categories.length > 0 ? this.categories : await this.$store.dispatch('getCategories')
            },

            /**
             * Handle file input change. Set file object.
             */
            onFileChange(e) {
                console.log('file', e.target.files[0]);
                //FIXME modifying props data not good
                this.material.file = e.target.files[0];
                console.log('file changed', this.errors);
                this.$nextTick(() => this.errors.remove('file'))
            },

            /**
             * Trigger file select prompt.
             */
            onFileUpload(ev) {
                this.$refs.fileUpload.click();
            },

            /**
             * Handle form submit. Validate and save material.
             */
            save() {
                this.$validator.validateAll()
                    .then(result => { if (result) this.saveMaterial() })
            },

            /**
             * Save material.
             * @returns {*|Promise<T>}
             */
            saveMaterial() {
                if (this.submitting) return;

                //Clone material and modify categories, remove owner, etc.
                const material = _.clone(this.material);
                material.categories = material.categories.filter(Boolean).map(c => c.id);
                delete material.owner;

                this.submitting = true;

                const method = material.id ? 'update' : 'create';
                return materials[method](material, this.handleUploadProgressEvent)
                    .then(response => {
                        this.$notify({ title: 'Darbība izdevās!', text: 'Materiāls saglabāts' });
                        this.$emit('update:material', Object.assign({}, response.data.data));
                        this.submitting = false;
                        this.progress = 100;
                        return response;
                    }, response => {

                        console.log('fail', response);

                        if (response.status === 413) {
                            this.errors.add('file', 'Pievienotais fails ir pārāk liels.', 'material')
                        }

                        const errors = response.data.errors;

                        // Record errors for available fields only
                        for (let field in errors) {
                            if (!errors.hasOwnProperty(field)) continue;

                            if (this.material.hasOwnProperty(field)) {
                                this.errors.add(field, errors[field][0], 'material')
                            }
                        }

                        if (!this.errors.any()) {
                            this.$notify({
                                title: 'Pievienot materiālu neizdevās!',
                                text: 'Materiālu pievienot neizdevās dēļ servera kļūdas. Lūdzu, pārbaudi datus un mēģini vēlreiz. Ja problēma atkārtojas, sazinies ar lapas administratoru',
                                type: 'error',
                                duration: 5*1000
                            });
                        }

                        this.submitting = false;
                        return response;
                    })
                    .catch(error => {
                        this.$notify({
                            title: 'Pievienot materiālu neizdevās!',
                            text: 'Materiālu pievienot neizdevās dēļ servera kļūdas. Lūdzu, pārbaudi datus un mēģini vēlreiz. Ja problēma atkārtojas, sazinies ar lapas administratoru',
                            type: 'error',
                            duration: 5*1000
                        });
                        this.submitting = false;
                        throw error;
                    })
            },

            /**
             * Handle upload progress event. Set progress.
             * @param e
             */
            handleUploadProgressEvent(e) {
                if (e.lengthComputable) {
                    this.progress = Math.round( (e.loaded * 100) / e.total );
                }
            },

            basicType(material) {
                return materials.basicType(material);
            }
        },

        computed: {

            ...mapGetters(['user', 'categories']),

            uriValidationRule: function () {
                return this.material.type === MATERIAL_TYPE_LINK ? 'required|url|max:2083' : 'url|max:2083';
            },

            /**
             * Get theme category nodes from pre-loaded tree based on selected class category
             */
            themeCategoryNodes() {
                if (this.classCategory) {
                    const t = this.categories.find(c => c.category_id === this.classCategory.id);
                    return typeof t === 'undefined' ? [] : t.children;
                } else {
                    return [];
                }
            },

            /**
             * Get type category nodes from pre-loaded tree based on selected theme category
             */
            typeCategoryNodes() {
                if (this.themeCategory) {
                    const t = this.themeCategoryNodes.find(c => c.category_id === this.themeCategory.id);
                    if (this.material.type === 'link') {
                        return typeof t === 'undefined' ? [] : t.children.filter(function (c) { return c.category.title === 'Noderīgas saites'; });
                    } else {
                        return typeof t === 'undefined' ? [] : t.children.filter(function (c) { return c.category.title !== 'Noderīgas saites'; });
                    }
                } else {
                    return [];
                }
            },

            /*
             * Get the material class category match from pre-loaded categories
             * Set the selected category to categories array
             */
            classCategory: {
                set: function(val) {
                    this.material.categories = [val, this.themeCategory, this.typeCategory].filter(Boolean);
                },
                get: function () {
                    if (!this.categories) return null;

                    const classCategoryNode = this.categories.find(node => {
                        return this.material.categories.find(cat => cat.id === node.category_id)
                    });

                    return classCategoryNode ? classCategoryNode.category : null;
                }
            },

            /*
             * Get the material theme category match from computed theme category nodes branch
             * Set the selected category to categories array
             */
            themeCategory: {
                set: function (val) {
                    this.material.categories = [this.classCategory, val, this.typeCategory].filter(Boolean);
                },
                get: function () {
                    if (!this.themeCategoryNodes) return null;

                    const themeCategoryNode = this.themeCategoryNodes.find(node => {
                        return this.material.categories.find(cat => cat.id === node.category_id)
                    });

                    return themeCategoryNode ? themeCategoryNode.category : null;
                }
            },

            /*
             * Get the material type category match from computed type category nodes branch
             * Set the selected category to categories array
             */
            typeCategory: {
                set: function (val) {
                    this.material.categories = [this.classCategory, this.themeCategory, val].filter(Boolean);
                },
                get: function () {
                    if (!this.typeCategoryNodes) return null;

                    const typeCategoryNode = this.typeCategoryNodes.find(node => {
                        return this.material.categories.find(cat => cat.id === node.category_id)
                    });

                    return typeCategoryNode ? typeCategoryNode.category : null;
                }
            }

        },

        watch: {

            /*
             * When theme categories change, unset selected theme and type categories
             */
            'themeCategoryNodes': function (val, oldVal) {
                if ((typeof val === 'undefined' || !val)
                    || (this.themeCategory && val.length > 0 && !val.find(node => this.themeCategory.id === node.category_id))) {
                    this.themeCategory = null;
                    this.typeCategory = null;
                }
            },

            /*
             * When type categories change, unset selected type category
             */
            'typeCategoryNodes': function (val, oldVal) {
                if ((typeof val === 'undefined' || !val)  || (this.typeCategory && val.length > 0 && !val.find(node => this.typeCategory.id === node.category_id))) {
                    this.typeCategory = null;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    @include foundation-progress-element;

    .material-form {
        .material-file-input {
            @include clearfix();

            margin-bottom: 1rem;

            h6 {
                margin-top: 0.4em;
            }

            .material-icon {
                float: left;
                margin-right: 1rem;
            }

            .button {
                margin-bottom: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/materials/MaterialForm.vue